import * as React from "react";
import { Input } from "../../../../components/ui/input";
import { Button } from "../../../../components/ui/button";

export function ExistingTrailersPicker({
  existing,
  selected,
  onPick,
}) {
  const [q, setQ] = React.useState("");
  const selectedVins = new Set((selected ?? []).map((v) => v.vin));
  const filtered = (existing ?? [])
    .filter((t) => !selectedVins.has(t.vin))
    .filter((t) => {
      const hay = `${t.year} ${t.make} ${t.model} ${t.vin} ${t.bodyType}`.toLowerCase();
      return hay.includes(q.toLowerCase());
    });

  return (
    <div className="space-y-3">
      <Input placeholder="Search by make/model/VIN/body…" value={q} onChange={(e) => setQ(e.target.value)} />
      {filtered.length === 0 ? (
        <div className="rounded-md border p-4 text-sm text-gray-600">No existing trailers to show.</div>
      ) : (
        <div className="max-h-96 overflow-auto rounded-md border divide-y">
          {filtered.map((t) => (
            <div key={t.id ?? t.vin} className="p-3 flex items-center justify-between text-sm">
              <div>
                <div className="font-medium">{t.year} {t.make} {t.model}</div>
                <div className="text-xs text-gray-500">VIN {t.vin} — {t.bodyType}</div>
              </div>
              <Button size="sm" onClick={() => onPick(t)}>Add</Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
